import React from 'react';
import {TableBasic} from './styles';

export default () => (
  <TableBasic>
    <thead>
      <tr>
        <th colSpan={3} className="transparent"></th>
        <th colSpan={7} className="header-centered left-radio">
          WELLNESS
        </th>
        <th colSpan={6} className="header-centered">
          ACCOUNTABILITY
        </th>
      </tr>
      <tr>
        <th colSpan={1} className="header-centered">
          PLAYERS
        </th>
        <th colSpan={1} className="header-centered">
          ALERTS
        </th>
        <th colSpan={1} className="header-centered">
          EXAM DATE
        </th>
        <th colSpan={3} className="header-centered">
          ARM
        </th>
        <th colSpan={2} className="header-centered">
          BODY
        </th>
        <th colSpan={2} className="header-centered">
          SLEEP
        </th>
        <th colSpan={5} className="header-centered">
          ARM CARE
        </th>
      </tr>
      <tr className="font-medium blank">
        <th></th>
        <th></th>
        <th></th>
        <th>Latest</th>
        <th>Location</th>
        <th>7 Days Avg</th>
        <th>Latest</th>
        <th>7 Days Avg</th>
        <th>Latest</th>
        <th>7 Days Avg</th>
        <th>Custom Arm Care</th>
        <th>Current Streak</th>
        <th>7 Days Avg</th>
        <th>Longest Streak</th>
        <th>Total Sessions</th>
      </tr>
    </thead>
    <tbody>
      <tr className="azul">
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
      </tr>
      <tr>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
      </tr>
      <tr>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
      </tr>
      <tr>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
      </tr>
    </tbody>
  </TableBasic>
);
